import styled from "styled-components";
import { Link } from "react-router-dom";
import { Button, Table } from "semantic-ui-react";

export const Container = styled.div`
  width: 90%;
  max-width: 1100px;
  margin: 6% auto;

  background: #ffffff;
`;

export const Title = styled.h1`
  width: 100%;
  max-width: 1100px;

  margin: 0px auto 15px auto;
  padding-bottom: 5px;

  color: #000000;

  border-bottom: 1px solid rgba(0, 0, 0, 0.15);

  font-size: 28px;
  font-family: sans-serif;
  font-weight: 600;
`;

export const ContainerInputSearch  = styled.div`
  width: 100%;
  height: 50px;
  
  & i{
    height: 75% !important;
  }
`;


export const Input = styled.input`
  width: 100%;
  height: 35px;
  margin: 0;
  padding: 0.67857143em 1em;
  outline: 0;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
  font-family: sans-serif;
  font-weight: 400;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4px;
  -webkit-appearance: none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color 0.1s ease, border-color 0.1s ease;
`;

export const CreateButton = styled(Link)`
  width: 100px;
  height: 35px;

  margin-left: 3px;

  color: #000000;
  background: #e0e1e2;

  border-radius: 5px;

  font-family: sans-serif;
  font-size: 16px;
  font-weight: 600;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #cacbcd;
    font-weight: 700;
    color: #000000;
  }
`;

export const SemanticTable = styled(Table)`
  th {
    font-size: 14 !important;
    font-family: sans-serif !important;
  }

  tr {
    font-size: 12px;
    font-family: sans-serif;
    text-align: left;
    :hover {
      background: rgba(34, 36, 38, 0.1);
    }
  }
`;

export const StatusToggle = styled.a`
  color: #2185d0 !important;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    color: #2d8cd4 !important;
  }
`;

export const LinkRedirect = styled(Link)`
  color: #2185d0 !important;
  cursor: default;

  &:hover {
    text-decoration: none;
    color: #2d8cd4 !important;
  }
`;

export const SemanticButton = styled(Button)`
  background: none !important;
  border: none;
  i {
    color: #9999;
    :hover {
      color: ${(props) => (props.info === "delete" ? "red" : "#2185d0")};
    }
  }

  transition: all 0.6s;
`;

export const Span = styled.span`
  height: 30px;
  padding: 5px;
  font-size: 13px;
  line-height: 12px;
  text-transform: capitalize;
  font-weight: 600;
  text-align: center;
  background: #2185d0 !important;
  color: #ffffff;
  border-radius: 5px;
  display: flex !important;
  align-items: center;
  justify-content: center;
`;

export const SendEmail = styled.a`
  padding: 5px;
  background: #dddddd;
  color: #000000bf;
  border-radius: 5px;
  cursor: pointer;
`;

export const ModalButtonConfirm = styled.button`
  width: 120px;
  height: 40px;
  margin-left: 10px;
  background: rgb(33, 186, 69);
  color: #ffffff;
  font-family: sans-serif;
  font-size: 16px;
  font-weight: 700;
  border: 0;
  border-radius: 6px;
  cursor: pointer;

  & :hover {
    background: rgba(23, 202, 65, 1);
  }
`;

export const ModalButtonCancel = styled(ModalButtonConfirm)`
  background: #ff0000;
`;

export const Field = styled.div`
  width: 100%;
  margin: 15px 0px 0px 0px;
`;

export const Select = styled.select`
  display: block;
  height: auto;
  width: 65%;
  background: #fff;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 0.28571429rem;
  -webkit-box-shadow: 0 0 0 0 transparent inset;
  box-shadow: 0 0 0 0 transparent inset;
  padding: 0.62em 1em;
  color: rgba(0, 0, 0, 0.87);
  -webkit-transition: color 0.1s ease, border-color 0.1s ease;
  transition: color 0.1s ease, border-color 0.1s ease;
`;

export const Label = styled.label`
  font-size: 13px;
  font-weight: 600;

  color: rgba(0, 0, 0, 0.87);
`;
